import Vue from 'vue'
import toastr from '../toastr'
import VueResource from 'vue-resource'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import mixins from '../mixins.js'
import TextInput from '../../component/dccore-form/textInput.vue'
import Multiselect from '../../component/dccore-form/multiselect.vue'
import NumberInput from '../../component/dccore-form/numberInput.vue'
import Checkbox from '../../component/simple-form/checkbox.vue'

if ($('#featureflag_form').length) {
  Vue.use(VueResource)

  new Vue({
    el: '#featureflag_form',
    components: {
      TextInput,
      RingLoader,
      Multiselect,
      NumberInput,
      Checkbox
    },
    mixins: [mixins],
    data: {
      form: {
        entity: {
          name: '',
          code: '',
          state: false,
        },
        options: {
          errors: {},
        }
      },
      loading: 0,
      entityId: null,
    },
    mounted: function () {
      if ($('#entity_id').length) {
        this.entityId = $('#entity_id').val()
        this.getFlag()
      }
    },
    methods: {
      createFeatureFlag: function (redirect) {
        $('.button-save').button('loading')
        let url = Routing.generate('api_post_feature_flag')

        let data = {
          data: this.form.entity,
        }

        Vue.http.post(url, data).then(() => {
          this.errors = { ingredient: {} }
          if (redirect) {
            $(location).attr('href', Routing.generate('feature_flag_grid'))
          } else {
            toastr.success(Translator.trans('feature_flag.create.created'))
          }
          $('.button-save').button('reset')
        }, response => {
          this.handleAjaxError(response, this.form.options)
        })
      },
      updateFeatureFlag: function (redirect) {

        this.loading++
        $('.button-save').button('loading')

        let url = Routing.generate('api_patch_feature_flag', { id: this.entityId })
        let data = {
          data: this.form.entity,
        }

        Vue.http.patch(url, data).then(() => {
          if (redirect) {
            $(location).attr('href', Routing.generate('feature_flag_grid'))
          } else {
            toastr.success(Translator.trans('feature_flag.update.updated'))
            this.form.options.errors = { ingredients:{} }
          }
          $('.button-save').button('reset')
        }, response => {
          this.handleAjaxError(response, this.form.options)
        })
        this.loading--
      },

      getFlag: function() {
        let url = Routing.generate('api_get_feature_flag', { id: this.entityId,
          context: 'edit' })
        this.loading++
        Vue.http.get(url).then(response => {
          this.form.entity = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      },
    }
  })
}
